import Velocity from 'velocity-animate';
// eslint-disable-next-line import/extensions
import 'velocity-animate/velocity.ui.min.js';

const translate = (el, value, done) => {
  Velocity(el, {
    translateX: value,
    delay: 300,
    duration: 700,
    complete: done,
  });
};

Velocity.defaults.display = 'flex';

export default {
  data() {
    return {
      transform: [0, '-100%'],
    };
  },
  methods: {
    tf_slideDown(el, done) {
      Velocity(el, 'slideDown', done);
    },
    tf_slideUp(el, done) {
      Velocity(el, 'slideUp', done);
    },
    tf_enterLeft(el, done) {
      translate(el, [0, '-100%'], done);
    },
    tf_leaveLeft(el, done) {
      translate(el, [0, '-100%'], done);
    },
    tf_enterRight(el, done) {
      translate(el, [0, '100%'], done);
    },
    tf_leaveRight(el, done) {
      translate(el, [0, '-100%'], done);
    },
    tf_fadeOut(el, done) {
      Velocity(el, 'fadeOut', done);
      Velocity(el, { display: 'flex' });
    },
    tf_fadeIn(el, done) {
      Velocity(el, 'fadeIn', done);
      Velocity(el, { display: 'flex' });
    },
    tf_scrollTo(el, container, done, offset) {
      Velocity(el, 'scroll',
        {
          duration: 750,
          offset,
          easing: 'ease-in',
          container,
        },
        done);
    },
  },
};
